<panel>
	<h1>{{ 'absence.header' | translate }}</h1>
	@if (loading) {
		<skeletons [defaultSkeletons]="3" />
	}
	@else {
		<scrollable>
			@for (category of eventCategories; track category.type) {
				<h2>{{ ('users.absence-types.' + category.type) | translate }}</h2>
				<section>
					<text-group>
						@for (user of category.users; track user.id) {
							<div>
								<a [trigger-soft-popup]="userDetails">{{ user.name }}</a>
								<soft-popup #userDetails [title]="user.name" [width]="280">
									<section one-column>
										@if (!user.missingImage) { <img class="portrait" [userImage]="user.id" (onMissingImage)="user.missingImage = true" /> }
										@else { <div><icon type="user" /></div> }
										<text-group>
											<div>
												<a href="mailto:{{ user.id | user: 'email' }}">
													<icon small type="envelope" /> {{ user.id | user: 'email' }}
												</a>
											</div>
											@if (user.start && user.end) {
											<div>
												<strong>{{ ('users.absence-types.' + category.type) | translate }}:</strong>
												{{ user.start | customDate:'shortDate' }} - {{ user.end | customDate:'shortDate' }}
											</div>
											}
										</text-group>
									</section>
								</soft-popup>
							</div>
						}
					</text-group>
				</section>
			}
		</scrollable>
	}
</panel>
